import DefaultSpinner from './_Default.spinner';
import DrinkSpinner from './_Drink.spinner';
import PulsingBubblesSpinner from './_PulsingBubbles.spinner';
import OrbitDotsSpinner from './_OrbitDots.spinner';
import BurgerSpinner from './_Burger.spinner';
import LargeSpinner from './_Large.spinner';
import LogoSpinner from './_Logo.spinner';
import { SpinnerType } from './types';

export type LoadingPlaceholderProps = {
    text?: string;
    spinnerType?: SpinnerType;
}

// Must stay hook-free: ApiResource takes this as its `renderLoading` prop and invokes it as a
// plain function inside its own render, so any hook here joins ApiResource's hook list and
// breaks hook ordering once loading finishes.
const LoadingPlaceholder = ({ text = undefined, spinnerType = 'default' }: LoadingPlaceholderProps): JSX.Element => {
    let Spinner: () => JSX.Element;
    switch (spinnerType) {
        case "lemonade":
        case "orange-juice":
            Spinner = () => <DrinkSpinner variant={spinnerType} />;
            break;
        case "pulsingBubbles":
            Spinner = PulsingBubblesSpinner;
            break;
        case "orbitDots":
            Spinner = OrbitDotsSpinner;
            break;
        case "burger":
            Spinner = BurgerSpinner;
            break;
        case "large":
            Spinner = LargeSpinner;
            break;
        case "logo":
            Spinner = LogoSpinner;
            break;
        case "default":
        default:
            Spinner = DefaultSpinner;
            break;
    }
    return (
        <div className="d-flex flex-column justify-content-center align-items-center p-4 text-primary h-auto">
            <Spinner />
            {!!text && <div className="mt-2">{text}</div>}
        </div>
    )
}

export default LoadingPlaceholder;
